import { t } from '@framework/i18n';
import { yup } from '@framework/validation';

export enum CitizenNationality {
  Italy = 'Italy',
  /** Nazioni UE che supportano il login con eIDAS */
  EU = 'EU',
  /** Altri paesi del mondo (non eIDAS) */
  ExtraEU = 'ExtraEU',
}

// Registrazione utente cittadino
export const CitizenRegisterSchema = yup
  .object({
    nationality: yup
      .string()
      .required()
      .oneOfEnum(CitizenNationality)
      .label(
        t('user-registration-form.nationality', 'Nazionalità'),
      ) as yup.StringSchema<CitizenNationality>,
    email: yup
      .string()
      .email()
      .lowercase()
      .required()
      .label(t('user-registration-form.email', 'Email')),
    password: yup
      .string()
      .required()
      .label(t('user-registration-form.password', 'Password')),
    confirmPassword: yup
      .string()
      .required()
      .when(['password'], (values, schema) => {
        const password = values[0];
        return schema.test({
          name: 'check-password',
          message: t(
            'user-registration-form.password-confirm-error',
            'Le password non coincidono.',
          ),
          test: value => {
            if (!value || typeof value !== 'string') return false;
            return value === password;
          },
        });
      })
      .label(t('user-registration-form.password-confirm', 'Conferma Password')),
    nome: yup
      .string()
      .required()
      .label(t('user-registration-form.profile.name', 'Nome')),
    cognome: yup
      .string()
      .required()
      .label(t('user-registration-form.profile.familyName', 'Cognome')),
    codiceFiscale: yup
      .string()
      .uppercase()
      .required()
      .label(
        t('user-registration-form.profile.fiscal-number', 'Codice Fiscale'),
      ),
    telefonoCellulare: yup
      .string()
      .nullable()
      .notRequired()
      .label(
        t('user-registration-form.profile.mobile-phone', 'Telefono Cellulare'),
      ),
    dataNascita: yup
      .string()
      .stringDate()
      .notRequired()
      .label(
        t('user-registration-form.profile.date-of-birth', 'Data di Nascita'),
      ),
    luogoNascita: yup
      .string()
      .required()
      .label(
        t('user-registration-form.profile.place-of-birth', 'Luogo di Nascita'),
      ),
    provinciaNascita: yup
      .string()
      .required()
      .label(
        t(
          'user-registration-form.profile.county-of-birth',
          'Provincia di Nascita',
        ),
      ),
    paeseProvenienza: yup
      .string()
      .required()
      .label(
        t('user-registration-form.profile.country', 'Paese di provenienza'),
      ),
    privacyAcceptance: yup
      .boolean()
      .required(
        t(
          'user-registration-form.profile.privacy-policy',
          'È necessario accettare la privacy policy',
        ),
      )
      .oneOf(
        [true],
        t(
          'user-registration-form.profile.privacy-policy',
          'È necessario accettare la privacy policy',
        ),
      )
      .label(t('user-registration-form.profile.agreement', 'Consenso')),
  })
  .noUnknown()
  .required();

export type ICitizenRegisterDto = yup.InferType<typeof CitizenRegisterSchema>;
